import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { msalAngularConfig, msalConfig, msalGuardConfig } from './auth.config';

export function provideAuth(): Provider[] {
  return [
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: MSAL_INSTANCE, useFactory: () => msalConfig },
    { provide: MSAL_GUARD_CONFIG, useFactory: () => msalGuardConfig },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: () => msalAngularConfig },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ];
}
